/**
 * Component Registry for 46 Penn Apartment Homes
 *
 * Inherits from @vibesites-price-brothers/theme-rise and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-price-brothers/theme-rise/registry';
import { ApplyNowActions } from './components/ApplyNowActions';
import { ContactForm } from './components/ContactForm';
import { FloorplansList } from './components/FloorplansList';
import { Footer } from './components/Footer';
import { GallerySeparator } from './components/GallerySeparator';
import { Hero } from './components/Hero';
import { PinnedCallouts } from './components/PinnedCallouts';
import { PropertyOverview } from './components/PropertyOverview';
import { ResidentAccess } from './components/ResidentAccess';
import { ScheduleTourForm } from './components/ScheduleTourForm';
import { SisterProperties } from './components/SisterProperties';
import { TabbedCallouts } from './components/TabbedCallouts';
import { ThankYouContent } from './components/ThankYouContent';

/**
 * Property-specific component overrides.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  ApplyNowActions,
  ContactForm,
  FloorplansList,
  Footer,
  GallerySeparator,
  Hero,
  PinnedCallouts,
  PropertyOverview,
  ResidentAccess,
  ScheduleTourForm,
  SisterProperties,
  TabbedCallouts,
  ThankYouContent,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
